import {Box, Typography, keyframes} from '@mui/material';
import {Dialog} from '@zoom/react-ui';

// Keyframe animations
const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1 125;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100 125;
    stroke-dashoffset: -25px;
  }
  100% {
    stroke-dasharray: 100 125;
    stroke-dashoffset: -125px;
  }
`;

// LoadingAnimation component
const LoadingAnimation = ({size = 100}) => {
  return (
    <Box
      sx={{
        'margin': '40px auto 38px',
        'position': 'relative',
        'width': size,
        'height': size,
        'transform': 'rotate(280deg)',
        '&:before': {
          content: '""',
          display: 'block',
          paddingTop: '100%',
        },
        '& .loading-svg': {
          animation: `${rotate} 2s linear infinite`,
          height: '100%',
          transformOrigin: 'center center',
          width: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          margin: 'auto',
        },
        '& .loading-path': {
          animation: `${dash} 4s ease-in-out infinite`,
        },
      }}
    >
      <Box
        component="svg"
        viewBox="25 25 50 50"
        className="loading-svg"
      >
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="10"
          strokeMiterlimit="10"
          strokeDashoffset="0"
          stroke="#e6e6e6"
          strokeLinecap="round"
          strokeDasharray="200 200"
        />
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="6"
          strokeMiterlimit="10"
          strokeDasharray="10 200"
          strokeDashoffset="0"
          stroke="#2d8cff"
          strokeLinecap="round"
          className="loading-path"
        />
      </Box>
    </Box>
  );
};

const contentSx = {
  fontSize: '1.375rem',
  fontWeight: 700,
  lineHeight: 1.5,
  textAlign: 'center',
  maxWidth: '17.5rem',
};

const descriptionSx = {
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: 1.5,
  textAlign: 'center',
  marginTop: '0.5rem',
  color: '#515079',
  maxWidth: '20rem',
};

const PayLoadingDialog = (props) => {
  const {content, description, open} = props;

  return (
    <Dialog
      open={open}
      footer={null}
      width={453}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding={3}
        minHeight={120}
      >
        <LoadingAnimation size={115} />
        <Typography sx={contentSx}>
          {content}
        </Typography>
        <Typography sx={descriptionSx}>
          {description}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default PayLoadingDialog;
